import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import * as selectors from '../../state-selectors/google-address-verify';

import GoogleAttributionItem from './GoogleAttributionItem';

export class GoogleAddressAttributions extends Component {
    render(){
        const { selectedAddress, addressPredictions } = this.props;
        return (
            !addressPredictions.length && selectedAddress && selectedAddress.htmlAttributions && selectedAddress.htmlAttributions.length ? (
            <div className="google-address-attributions">
                {selectedAddress.htmlAttributions.map((item, index) => (
                    <GoogleAttributionItem item={item} key={index} />
                ))}
            </div>
            ) : null
        );
    }
}

GoogleAddressAttributions.propTypes = {
    selectedAddress: PropTypes.shape({
        streetAddress: PropTypes.string,
        city: PropTypes.string,
        state: PropTypes.string,
        zip: PropTypes.string,
        formattedAddress: PropTypes.string,
        htmlAttributions: PropTypes.array,
        hasValidCity: PropTypes.bool,
        hasValidStreetAddress: PropTypes.bool,
        isValid: PropTypes.bool
    }),
    addressPredictions: PropTypes.arrayOf(PropTypes.shape({
        suggestion: PropTypes.string,
        placeId: PropTypes.string,
        active: PropTypes.bool,
        index: PropTypes.number,
        formattedSuggestion: PropTypes.object
    }))
};

const mapStateToProps = (state) => {
    return {
        selectedAddress: selectors.getSelectedAddress(state),
        addressPredictions: selectors.getAddressPredictions(state)
    }
};

export default connect(mapStateToProps)(GoogleAddressAttributions);
